import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type { GenerateXlsxRequest, GenerateXlsxResponse } from "../types/xlsx";

export async function generateXlsx(
  request: GenerateXlsxRequest
): Promise<GenerateXlsxResponse> {
  const { data, error } = await supabase.functions.invoke("api/generate-xlsx", {
    method: "POST",
    body: request,
  });

  await handleSupabaseFunctionError(error);

  if (!data || !data.entityData) {
    throw new Error("Invalid response format from generate-xlsx endpoint");
  }

  return data;
}
